export const getStatusText = (isCreatingOrder: boolean, isCreated: boolean, tempError: string | undefined) => {
  if (isCreatingOrder) {
    return 'Sender ordren';
  }
  if (isCreated) {
    return 'Ordren er sendt, du blir nå videresendt til betaling.';
  }
  return tempError || '';
};
